<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <paginated-table v-if="isLoaded" :title="tableTitle" :icon="tableIcon" :columns="columns" :data="reviews"
                @updatePagination="updatePagination"></paginated-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import PaginatedTable from '@/components/Tables/PaginatedTable.vue'
    import { getReviewStatusColumns } from '@/views/ReviewView/columns'
    import { reviewStatusLabel } from '@/views/ReviewView/label'

    import { reviewApi } from '@/api/api';

    export default {
        components: {
            PaginatedTable,
        },
        data() {
            return {
                // label
                tableTitle: reviewStatusLabel.tableTitle,
                tableIcon: "manage_search",

                // fields & columns
                columns: getReviewStatusColumns({
                    "edit": this.toEditReview,
                    "description" : this.toShowReview,
                }),

                // boolean
                isLoaded: false,

                // init data
                reviews: {
                    page_info: {
                        page: 1,
                        size: 5,
                        total_elements: 5,
                        total_pages: 1,
                    },
                    elements: [],
                },
                reviewer_idx: null,
            }
        },
        methods: {
            /**
             * 수정 작업 처리 메소드 
             */
            toEditReview(review) {
                if (review.status === "COMPLETED") {
                    alert("이미 완료된 심사입니다.");
                    return;
                } else {
                    this.$router.push({
                        name: "review-edit",
                    params: {
                        idx: review.idx,
                    }
                });
               }
            },
            toShowReview(review) {
                this.$router.push({
                    name: "review-detail",
                    params:{
                        idx: review.idx,
                    }
                });
            },
            /**
             * 리뷰 목록 조회 API 요청 메서드
             */
            fetchReviews(size, page) {
                const params = {
                    reviewer_idx: this.reviewer_idx,
                    is_completed: false,
                    size: size,
                    page: page,
                    sort_by: "idx",
                    direction: "desc",
                };

                this.isLoaded = false;
                reviewApi.getReviews(params).then(response => {
                    if (response && response.status === 200) {
                        this.reviews = response.data.response;
                        this.isLoaded = true;
                    } else {
                        this.isLoaded = true;
                        alert(reviewStatusLabel.apiRequestFailMessage);
                    }
                })
            },
            /**
             * Pagination 타입 명세
             * @typedef {Object} Conditions
             * @property {string} page - 페이지
             * @property {string} size - 사이즈
             * @property {string} total_elements - 전체 데이터 수 
             * @property {string} total_pages - 전체 페이지 수
             */

            /** 
             * 페이지네이션 업데이트 메서드
             *  
             * @description: 페이징 정보가 변경되면 하위 컴포넌트에서 정보를 받아 업데이트 및 API 요청
             * @params {Pagination} pagination
             */
            updatePagination(pagination) {
                this.reviews.page_info.size = pagination.size;
                this.reviews.page_info.page = pagination.page;

                this.fetchReviews(this.reviews.page_info.size, this.reviews.page_info.page);
            },
        },
        mounted() {
            this.reviewer_idx = this.userId;
            this.fetchReviews(this.reviews.page_info.size, this.reviews.page_info.page);
        },
        computed: {
            userId() {
                return this.$store.getters["auth/userId"];
            }
        }
    }
</script>
<style scoped>
    .right-button {
        display: flex;
        justify-self: flex-end;
        margin-right: 20px;
        margin-bottom: -15px;
    }
</style>